import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const wildlifeSnakeDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "wildlife-snake-detect-example",
  version: 1,
  title: "Wildlife observation",
  description: "Find snake among foliage",
  subdescription: "Zoom, crop, and inspect to identify fine objects",
  thumbnailUuid: BASE_ASSETS.wildlifeSnakeExample.uuid,
  assets: [BASE_ASSETS.wildlifeSnakeExample],
  detect: {
    mediaUuid: BASE_ASSETS.wildlifeSnakeExample.uuid,
    categories: ["snake"],
    config: {
      output: "box",
      enableThinking: true,
    },
  },
};
